import styled, { css } from 'styled-components';
import { H1Text } from '@prisjakt/ui/text/variants';
import { layout, media } from '@prisjakt/ui-base';

type Props = {
  $noMargins: boolean;
};

export const Header = styled.header<Props>(
  props => css`
    margin-top: ${layout.measurements.spacing150};
    margin-bottom: ${layout.measurements.spacing050};
    padding: 0 ${layout.measurements.spacing050};

    ${media.mediumDown`
      margin-top: ${
        props.$noMargins ? '0' : `${layout.measurements.spacing050}`
      };
    `}
  `
);

export const Title = styled(H1Text)<Props>(
  props => css`
    &::first-letter {
      text-transform: uppercase;
    }

    && {
      ${media.smallOnly`
      font-size: 1.5rem;
    `};
    }

    ${media.mediumDown`
      ${props.$noMargins && 'margin: 0'};
    `}
  `
);

export const Description = styled.div`
  max-width: 36em;
`;
